<template lang="pug">
.lucre-social-links
  ul
    li(v-for="link in links")
      a(:class="'icon-'+link.icon" :href="link.url" target="_blank"
        data-gtm='Social Links > Click' :data-gtm-value="link.icon")
</template>

<script>
export default {
  name: 'social-links',

  props: ['links']
}
</script>

<style lang="stylus">

.lucre-social-links
  position fixed
  right rem(40px)
  bottom @right

  @media(max-width tablet)
    left @right

  ul, li
    margin 0
    padding 0

  li
    list-style none
    display block

    a
      font-size 28px
      margin rem(16px) 0 0 0
      display inline-block

      @media(max-width tablet)
        color black
</style>



// WEBPACK FOOTER //
// src/components/global/SocialLinks.vue